<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <!-- 通知公告 -->
    <div class="notice"><noticebar :options=options></noticebar></div>

    <!-- 登出头像 -->
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <!-- 头像 -->
        <Avatar
        :username="name"
        :src="name"
        :background-color="extractColorByName(name)"
        color="#fff"
        style="width:40px; height:40px;"
        class="user-avatar"
        :inline="true"
        >
        </Avatar>
        <!-- 用户名称 -->
        <span class="user-name">{{name}}</span>
        <!-- <img class="user-avatar" :src="avatar"> -->
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">

<!--        <router-link :to="{path:'user/profile',query:{userId:this.userId}}">-->
        <router-link to="/user/profile">
          <el-dropdown-item>
            个人中心
          </el-dropdown-item>
        </router-link>
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import noticebar from '@/components/NoticeBar'
import Avatar from 'vue-avatar'
import { getInfo } from "@/api/login";

export default {
  components: {
    Breadcrumb,
    Hamburger,
    noticebar,
    Avatar
  },
  data() {
      return {
        userId:undefined,
          // noticebar 组件的配置项
          options: {
              icon:'', // elementui 图标
              iconSize: '25px', // icon大小（正方形默认16px）
              size: '16px', // 通知内容文字大小（默认16px）
              color: '#1989fa', // 通知内容文字颜色(默认#f60)
              background: '', //背景颜色(默认#fff7cc)
              delay: '1000', // 动画延迟时间(默认一秒后开始滚动，单位毫秒)
              speed: '50', // 滚动速率默认50 (px/s)
              status: 1, //是否开启文字滚动 0 不开启 非0 开启
          }
      };
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'name'
    ])
  },
  methods: {
    getUserId(){
      getInfo().then((response) =>{
        console.log(response.data)
        this.userId = response.data.userId;
      })
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    extractColorByName (name) {
      var str = ''
      for (var i = 0; i < name.length; i++) {
        str += parseInt(name[i].charCodeAt(0), 10).toString(16)
      }
      return '#0c' + str.slice(1, 2)
    }
  },
  created() {
    this.getUserId();
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .user-name {
        font-size: 16px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
  .notice {
    position: absolute;
    right: 150px;
    top:10px;
    display: inline-block;
    // width:25%;
    height: 38px;
    line-height: 38px;
    // border: 1px solid rgb(207, 207, 207) ;
    // border-radius:5px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue